var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'dark-mode': _vm.darkMode },attrs:{"id":"app"}},[_c('Nav'),_c('router-view'),_c('Footer'),_c('ChatBot'),_c('CanvasAnimation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }